export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10555.e2e77a83.jpg";